<template>
    <div v-show="feesCollectionPolicy === PAYMENT_PER_ENTRY">
        <input type="text"
               autocomplete="off"
               title="Paid Amount"
               ref="paid_amount_input"
               v-model="entry.paid_amount"
               v-show="shouldShowPaidAmountInput()"
               v-bind:class="{ 'is-invalid' : error }"
               @focusin="emptyInputOnZeroValue()"
               @focusout="setZeroValueOnEmptyInput()"
               class="vertical text-right form-control"/>
        <small class="invalid-feedback d-block"
               v-show="error !== ''">
            {{ error || '' }}
        </small>
    </div>
    <div v-show="feesCollectionPolicy === PRIORITIZED_PAYMENT"
         class="text-right">
        {{ Number(entry.paid_amount || 0).toLocaleString() }}
    </div>
</template>

<script>
const PAYMENT_PER_ENTRY = 'payment_per_entry'
const PRIORITIZED_PAYMENT = 'prioritized_payment'

export default {
    props: {
        entry: {
            type: Object,
            required: true,
        },
        feesCollectionPolicy: {
            type: String,
            required: true,
        },
        error: {
            type: String,
            required: false,
        },
    },
    computed: {
        PAYMENT_PER_ENTRY: () => PAYMENT_PER_ENTRY,
        PRIORITIZED_PAYMENT: () => PRIORITIZED_PAYMENT,
    },
    methods: {
        shouldShowPaidAmountInput() {
            return (this.entry.amount - this.entry.waived_amount) > 0
        },
        emptyInputOnZeroValue() {
            this.$nextTick(() => {
                const inputElem = this.$refs['paid_amount_input']
                inputElem.value = inputElem.value > 0 ? Number(inputElem.value).toString() : ''
                if (inputElem.value > 0) {
                    inputElem.select()
                }
            })
        },
        setZeroValueOnEmptyInput() {
            this.$nextTick(() => {
                const inputElem = this.$refs['paid_amount_input']
                inputElem.value = inputElem.value !== '0' ? Number(inputElem.value).toString() : '0'
            })
        },
    }
}
</script>

<style scoped>

</style>
